import {
  RazorImageFallback,
  RazorRadioCheck,
} from "../../../../../components/razor-reuse";
import React, { useState } from "react";
import CollapseFragment from "../../../../../components/fragment/collapse/CollapseFragment";
import "../../../../../styles/dashboard/customer/CustomersIndex.css";
import { useSelector } from "react-redux";
import RootState from "../../../../../redux/type";

const DocumentsIndex = () => {
  const [bvnOpen, setbvnOpen] = useState(false);
  const [otherOpen, setotherOpen] = useState(false);
  const [proffOpen, setProofOpen] = useState(false);

  // Endpoint for Customer details
  const { customer } = useSelector((state: RootState) => state?.customer);

  const bvnList = [{ name: "Selfie", active: false }];

  const proofList = [
    { name: "Driver’s License", active: false },
    { name: "Voter’s Card", active: false },
    { name: "International Passport", active: false },
    { name: "NIMC", active: false },
  ];

  const otherList = [
    {
      name: "Proof of Address",
      active: customer?.kyc?.proof_of_address_verified ? true : false,
    },
    { name: "Utility Bill", active: true },
    { name: "International Passport", active: true },
    { name: "Bank Statement", active: true },
  ];
  return (
    <div className="document-customer-single-wrapper-index-smart-send">
      {/* left wrap start */}
      <div className="left-wrap-box">
        <div className="all-document-big-wrapper">
          {/* selfie collapse box start */}
          <CollapseFragment
            className="big-collapse-wrap-box"
            iconColor="rgba(117, 125, 138, 1)"
            titleColor="rgba(117, 125, 138, 1)"
            title="Selfie"
            collapseHeight="50rem"
          >
            <div className="bottom-content-box">
              {/* left wrap start */}
              <div className="left-wrap">
                {/* file detail box start */}
                <div className="file-detail-box">
                  <div className="file-box"></div>
                  <div className="label-value-box-wrapper">
                    {/* label value box start */}
                    <div className="label-value-box">
                      <p className="label">Current Upload:</p>
                      <p className="value">NIL</p>
                    </div>
                    {/* label value box end */}
                    {/* label value box start */}
                    <div className="label-value-box">
                      <p className="label">Date Uploaded:</p>
                      <p className="value">NIL</p>
                    </div>
                    {/* label value box end */}
                    {/* label value box start */}
                    <div className="label-value-box">
                      <p className="label">Status:</p>
                      <p className="value">NIL</p>
                    </div>
                    {/* label value box end */}
                  </div>
                </div>
                {/* file detail box end*/}
              </div>
              {/* left wrap end */}
              {/* right wrap start */}
              <div className="right-wrap">
                {/* file detail box start */}
                <div className="file-detail-box">
                  <div className="file-box"></div>
                  <div className="label-value-box-wrapper">
                    {/* label value box start */}
                    <div className="label-value-box">
                      <p className="label">Current Upload:</p>
                      <p className="value">NIL</p>
                    </div>
                    {/* label value box end */}
                    {/* label value box start */}
                    <div className="label-value-box">
                      <p className="label">Date Uploaded:</p>
                      <p className="value">NIL</p>
                    </div>
                    {/* label value box end */}
                    {/* label value box start */}
                    <div className="label-value-box">
                      <p className="label">Status:</p>
                      <p className="value">NIL</p>
                    </div>
                    {/* label value box end */}
                  </div>
                </div>
                {/* file detail box end*/}
              </div>
              {/* right wrap end */}
            </div>
          </CollapseFragment>
          {/* selfie collapse box end */}
          {/* Driver’s License collapse box start */}
          <CollapseFragment
            className="big-collapse-wrap-box"
            iconColor="rgba(117, 125, 138, 1)"
            titleColor="rgba(117, 125, 138, 1)"
            title="Driver’s License"
            collapseHeight="50rem"
          >
            <div className="bottom-content-box">
              {/* left wrap start */}
              <div className="left-wrap">
                {/* file detail box start */}
                <div className="file-detail-box">
                  <p className="file-title">ID Front</p>
                  <div className="file-box"></div>
                  <div className="label-value-box-wrapper">
                    {/* label value box start */}
                    <div className="label-value-box">
                      <p className="label">Current Upload:</p>
                      <p className="value">NIL</p>
                    </div>
                    {/* label value box end */}
                    {/* label value box start */}
                    <div className="label-value-box">
                      <p className="label">Date Uploaded:</p>
                      <p className="value">NIL</p>
                    </div>
                    {/* label value box end */}
                    {/* label value box start */}
                    <div className="label-value-box">
                      <p className="label">Status:</p>
                      <p className="value">NIL</p>
                    </div>
                    {/* label value box end */}
                  </div>
                </div>
                {/* file detail box end*/}
              </div>
              {/* left wrap end */}
              {/* right wrap start */}
              <div className="right-wrap">
                {/* file detail box start */}
                <div className="file-detail-box">
                  <p className="file-title">ID Back</p>
                  <div className="file-box"></div>
                  <div className="label-value-box-wrapper">
                    {/* label value box start */}
                    <div className="label-value-box">
                      <p className="label">Current Upload:</p>
                      <p className="value">NIL</p>
                    </div>
                    {/* label value box end */}
                    {/* label value box start */}
                    <div className="label-value-box">
                      <p className="label">Date Uploaded:</p>
                      <p className="value">NIL</p>
                    </div>
                    {/* label value box end */}
                    {/* label value box start */}
                    <div className="label-value-box">
                      <p className="label">Status:</p>
                      <p className="value">NIL</p>
                    </div>
                    {/* label value box end */}
                  </div>
                </div>
                {/* file detail box end*/}
              </div>
              {/* right wrap end */}
            </div>
          </CollapseFragment>
          {/* Driver’s License collapse box end */}
          {/* Proof of Address collapse box start */}
          <CollapseFragment
            className="big-collapse-wrap-box"
            iconColor="rgba(117, 125, 138, 1)"
            titleColor="rgba(117, 125, 138, 1)"
            title="Proof of Address"
            collapseHeight="50rem"
          >
            <div className="bottom-content-box">
              {/* left wrap start */}
              <div className="left-wrap">
                {/* file detail box start */}
                <div className="file-detail-box">
                  <RazorImageFallback
                    url={customer?.kyc?.proof_of_address}
                    className="file-img-box"
                  >
                    <figure className="file-box"></figure>
                  </RazorImageFallback>
                  <div className="label-value-box-wrapper">
                    {/* label value box start */}
                    <div className="label-value-box">
                      <p className="label">Current Upload:</p>
                      <p className="value">NIL</p>
                    </div>
                    {/* label value box end */}
                    {/* label value box start */}
                    <div className="label-value-box">
                      <p className="label">Date Uploaded:</p>
                      <p className="value">NIL</p>
                    </div>
                    {/* label value box end */}
                    {/* label value box start */}
                    <div className="label-value-box">
                      <p className="label">Status:</p>
                      <p className="value">
                        {customer?.kyc?.proof_of_address_verified
                          ? "Accepted"
                          : "NIL"}
                      </p>
                    </div>
                    {/* label value box end */}
                  </div>
                </div>
                {/* file detail box end*/}
              </div>
              {/* left wrap end */}
              {/* right wrap start */}
              <div className="right-wrap">
                {/* file detail box start */}
                <div className="file-detail-box">
                  <div className="file-box"></div>
                  <div className="label-value-box-wrapper">
                    {/* label value box start */}
                    <div className="label-value-box">
                      <p className="label">Current Upload:</p>
                      <p className="value">NIL</p>
                    </div>
                    {/* label value box end */}
                    {/* label value box start */}
                    <div className="label-value-box">
                      <p className="label">Date Uploaded:</p>
                      <p className="value">NIL</p>
                    </div>
                    {/* label value box end */}
                    {/* label value box start */}
                    <div className="label-value-box">
                      <p className="label">Status:</p>
                      <p className="value">NIL</p>
                    </div>
                    {/* label value box end */}
                  </div>
                </div>
                {/* file detail box end*/}
              </div>
              {/* right wrap end */}
            </div>
          </CollapseFragment>
          {/* Proof of Address collapse box end */}
        </div>
      </div>
      {/* left wrap end */}
      {/* right wrap start */}
      <div className="right-wrap-box">
        <div className="kyc-wrapper-info-box">
          <p className="title">KYC Information</p>
          {/* bvn collapse one start */}
          <CollapseFragment
            title="BVN Document"
            titleColor="rgba(115, 71, 146, 1)"
            iconColor="rgba(115, 71, 146, 1)"
            disableDefaultControl
            collapse={bvnOpen}
            onCollapse={() => {
              setbvnOpen(!bvnOpen);
            }}
          >
            <div className="name-toggle-check-box-wrapper">
              {bvnList?.map((chi, idx) => {
                return (
                  <div key={idx} className="name-toggle-check-box">
                    <p className="name">{chi?.name}</p>
                    <RazorRadioCheck
                      color="white-light"
                      key={`${chi?.name}-${idx}`}
                      checked={chi?.active}
                      id={`${chi?.name}-${idx}` as any}
                      className="radio"
                    />
                  </div>
                );
              })}
            </div>
          </CollapseFragment>
          {/* bvn collapse one end */}
          {/* bvn collapse one start */}
          <CollapseFragment
            title="Proof of Identity"
            titleColor="rgba(115, 71, 146, 1)"
            iconColor="rgba(115, 71, 146, 1)"
            disableDefaultControl
            collapse={proffOpen}
            onCollapse={() => {
              setProofOpen(!proffOpen);
            }}
          >
            <div className="name-toggle-check-box-wrapper">
              {proofList?.map((chi, idx) => {
                return (
                  <div key={idx} className="name-toggle-check-box">
                    <p className="name">{chi?.name}</p>
                    <RazorRadioCheck
                      color="white-light"
                      key={`${chi?.name}-${idx}`}
                      checked={chi?.active}
                      id={`${chi?.name}-${idx}` as any}
                      className="radio"
                    />
                  </div>
                );
              })}
            </div>
          </CollapseFragment>
          {/* bvn collapse one end */}
          {/* bvn collapse one start */}
          <CollapseFragment
            title="Others"
            titleColor="rgba(115, 71, 146, 1)"
            iconColor="rgba(115, 71, 146, 1)"
            disableDefaultControl
            collapse={otherOpen}
            onCollapse={() => {
              setotherOpen(!otherOpen);
            }}
          >
            <div className="name-toggle-check-box-wrapper">
              {otherList?.map((chi, idx) => {
                return (
                  <div key={idx} className="name-toggle-check-box">
                    <p className="name">{chi?.name}</p>
                    <RazorRadioCheck
                      color="white-light"
                      key={`${chi?.name}-${idx}`}
                      checked={true}
                      // checked={chi?.active}
                      onChange={() => {}}
                      id={`${chi?.name}-${idx}` as any}
                      className="radio"
                    />
                  </div>
                );
              })}
            </div>
          </CollapseFragment>
          {/* bvn collapse one end */}
        </div>
      </div>
      {/* right wrap end */}
    </div>
  );
};

export default DocumentsIndex;
